import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL
class AuthService {
  login(loginModel) {
    return axios.post(API_URL + '/login', loginModel)
  }
}

export default new AuthService()
